import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { AppointmentSchedulingConfiguration } from '../../config/appointment_scheduling_configuration';
import { AppointmentsAvailableTimesQuery } from '../../queries/appointments_available_times_query';
import { AppointmentsLocationsQuery } from '../../queries/appointments_locations_query';
import { AppointmentsServiceCategoriesQuery } from '../../queries/appointments_service_categories_query';
import { AppointmentButtonServant } from '../../servants/appointment_button_servant';
import { AppointmentRemindersServant } from '../../servants/appointment_reminders_servant';
import { AppointmentUsersourceServant } from '../../servants/appointments_usersource_servant';
import MyAppointmentsStateService from '../../services/my_appointment_state_service';
import { IAlternateAppointmentConfirm } from '../../types/appointment_interfaces';
import { ILocation } from '../../types/appt_interfaces';
import { TAppointmentLocationsOrganizersUsersource } from '../../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../../usersources/appointment_reason_usersource';

export class AlternateAppointmentTimesController {
  private showConfirm: boolean = false;
  public model: IAlternateAppointmentConfirm;
  private selectedLocationId: number;
  public showLocations: boolean;
  isRequestWorkflowBlocked: boolean = false;

  constructor(
    public ngAppointmentsLocationsQuery: AppointmentsLocationsQuery,
    public ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
    private ngAlternateAppointmentTimesUsersource: any,
    private accountModel: AccountModel,
    private log: any,
    private ngAppointmentsServiceCategoriesQuery: AppointmentsServiceCategoriesQuery,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
    private ngMyAppointmentsStateService: MyAppointmentsStateService,
    private clearAllAppointmentsDataSourcesCommand: ICommand,
    private alternateAppointmentTimesConfirmationCommand: ICommand,
    private ngAppointmentsAvailableTimesQuery: AppointmentsAvailableTimesQuery,
    private ngAppointmentUsersourceServant: AppointmentUsersourceServant,
    private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration,
    private ngAppointmentButtonServant: AppointmentButtonServant
  ) {}

  $onInit() {
    this.isRequestWorkflowBlocked =
      !this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.can_request;
    this.selectedLocationId = this.ngAlternateAppointmentTimesUsersource.read().selectedLocation.id || -1;
    this.showLocations =
      !!this.ngAlternateAppointmentTimesUsersource.availability &&
      this.ngAlternateAppointmentTimesUsersource.availability.length > 0;
    this.ngAppointmentButtonServant.configButton({
      buttonText: 'Confirm',
      isDisabled: !this.isGotoNextStep(),
      action: () => this.ngMyAppointmentsStateService.goToAlternateTimesConfirm()
    });
    this.ngMyAppointmentsStateService.stateLoaded();
  }

  showLocationsOptions(): void {
    this.showLocations = true;
  }

  setAvailability(event: JQueryEventObject): void {
    this.ngAlternateAppointmentTimesUsersource.availability = _4.get(event.target, 'value');
    this.ngAppointmentButtonServant.isDisabled = !this.isGotoNextStep();
  }

  selectAppointmentLocation(location: ILocation) {
    this.ngAlternateAppointmentTimesUsersource.set('selectedLocation', location);
    this.ngAppointmentButtonServant.isDisabled = !this.isGotoNextStep();
  }

  isItemSelected(itemName: string): boolean {
    return this.ngAlternateAppointmentTimesUsersource.read().selectedLocation === itemName;
  }

  private canGotoConfirm(): boolean {
    return (
      !_.isEmpty(this.ngAlternateAppointmentTimesUsersource.availability) &&
      !_.isEmpty(this.ngAlternateAppointmentTimesUsersource.read().selectedLocation)
    );
  }

  isGotoNextStep(): boolean {
    return (
      !_.isEmpty(this.ngAlternateAppointmentTimesUsersource.availability) &&
      !_.isEmpty(this.ngAlternateAppointmentTimesUsersource.read().selectedLocation) &&
      !this.isRequestWorkflowBlocked
    );
  }
}

angular
  .module('capability-ng-appointments')
  .controller('AlternateAppointmentTimesController', AlternateAppointmentTimesController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/alternate_appointment_times/alternate_appointment_times.ts